import {DynamicColumnTable} from '@/components/organisms'
import {useStoreListData} from '@/services/storeListService'

const columns = [
  {
    name_of_db_column: 'storeName',
    label_of_column: 'Store Name',
    order_of_column: 2,
    filterable: true,
    cellData: ctx => {
      return <button className="text-primary-400">{ctx.row.original.storeName}</button>
    },
  },
  {
    name_of_db_column: 'erpId',
    label_of_column: 'ERP ID',
    order_of_column: 3,
    filterable: true,
  },
  {
    name_of_db_column: 'phoneNumber',
    label_of_column: 'Phone Number',
    order_of_column: 4,
    filterable: true,
  },
  {
    name_of_db_column: 'email',
    label_of_column: 'Email',
    order_of_column: 5,
    filterable: true,
  },
  {
    name_of_db_column: 'currentPoints',
    label_of_column: 'Current Points',
    order_of_column: 6,
    filterable: true,
  },
]

export const StoreList = () => {
  const {isLoading, isError, rowData} = useStoreListData()

  if (isError) {
    return <span>Error Loading the data from API</span>
  }

  if (isLoading) {
    return <span>Loading Table Data</span>
  }

  return (
    <DynamicColumnTable
      pklass={`font-normal text-balance`}
      columns={columns}
      records={rowData}
      isDark={true}
      tableDescription=""
      tableHeader=""
    />
  )
}
